import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getLegalEntity } from '@cemex/cmx-client-layout';

export const getOneClickProfileState = createSelector(getOneClickState, state => state.profileState);

export const getOneClickProfileResult = createSelector(getOneClickProfileState, state => state.result);

export const getOneClickPreloadedOrder = createSelector(getOneClickProfileState, state => state.presetOrder);

export const getOneClickPreloadedOrderLoading = createSelector(getOneClickProfileState, state => state.loading);

export const getOneClickBuilderEditMode = createSelector(getOneClickProfileState, state => !!state.isEditMode);

export const oneClickStateCustomer = createSelector(getOneClickState, getLegalEntity, (oneClick, customer) => ({
  oneClick,
  customer,
}));

export const getOneClickProfileStatePrices = createSelector(getOneClickProfileState, state => state.prices);
